module.exports = __webpack_public_path__ + "img/loading.d98a68a1.png";